exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LanguageButton{background-color:var(--affiliation-registration-header-text-color);color:var(--affiliation-registration-header-footer-color);transition:background-color .45s;border-width:0;border-style:solid;border-radius:4px;padding:.25rem;margin:.25rem}.LanguageButton:hover{background-color:var(--affiliation-registration-next-button-color);color:var(--affiliation-registration-header-text-color)}@media (min-width:768px){.LanguageButton{padding:.25rem;margin:.25rem .75rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js?sourceMap!./registration-react/components/LanguageButton/LanguageButton.scss
// module id = 806
// module chunks = 0